export const rechargeManagement = {
	title: "Gestión de saldo",
	titleWithPeriod: "Recargas de los últimos {{period}} días",
	titleWithoutPeriod: "Recargas",
	editButton: "Editar saldos seleccionados",
	statusSelect: "Estado",
	statusPlaceholder: "Filtre por estado",
	employeesSelect: "Empleado que creó",
	employeesPlaceholder: "Filtre por empleado",
	clientSearch: "CPF del cliente",
	clientPlaceholder: "Filtre por cliente",
	period: "Período",
	editTitle_other: "Editando {{value}} saldos",
	editTitle_one: "Editando saldo",
	save: "Guardar cambios",
	validPlace: "Locales en los que los saldos son válidos",
	validPlacePlaceholder:
		"Haga clic para seleccionar locales. Todos los locales previamente válidos perderán la validez si no están en esta selección, menos el local en el que la recarga fue originalmente realizada",
	expirationDate: "Fecha de expiración",
	valid: "Válida por más {{value}} días",
	expireToday: "Expira hoy",
	expired: "Expirada hace {{value}} días",
	required: "Campo obligatorio",
	columns: {
		id: "ID",
		date: "Fecha de creación",
		method: "método de pago",
		author: "Empleado que creó",
		user: "Cliente",
		totalValue: "Valor",
		expiresAt: "Fecha de expiración",
		validPlaces: "válido en los locales",
		status: "Estado",
		rechargeType: "Tipo",
		minimumConsumption: "Consumo Anticipado",
		bonus: "Bono",
		recharge: "Recarga",
	},
	activeLabel: "Válida",
	expiredLabel: "Expirada",
	refundedLabel: "Reembolsada",
	emptyTitle: "No hubo saldos",
	emptySubtitle: "No hubo saldos en el período seleccionado",
	warningMessage:
		"Esta recarga continuará pudiendo ser usada <b>aunque aparezca como reembolsada en el historial</b> hasta que el cliente sea registrado nuevamente si ya está en su ZigTag.",
	hasBonusOrMinimumConsumptionPlaceIdsError:
		"Edición de Locales bloqueada para Bono y Consumo anticipado",
	hasBonusOrMinimumConsumptionexpiresAtError:
		"Para Consumo anticipado, edición solo para fechas expiradas",
	editAllButton: "Editar todos los saldos",
	editAllMessage: "¿Está seguro que desea editar todos los saldos?",
	editAllConfirm: "Sí, ir a edición",
	order: "Ordenar",
	asc: "Más antiguo",
	desc: "Más reciente",
};
